// @flow

import _ from 'lodash';
import localforage from 'localforage';

import Map from './Map.jsx';
import App from './App.jsx';

import {takeDir, flatten_nums} from './utils.js';

import type {T_Point, T_NumPair, T_EscalaLyr} from './types.js';
import type {T_Escala} from './Escala.jsx';


export type T_InfoLim = {error: string} | {elemRange: [number, number], inverted: boolean};


export type T_ImgFile = {
  img_filepath: string,
  x_scale     : number,
  y_scale     : number,
  xcorner1    : number,
  ycorner1    : number,
  img_w       : number,
  img_h       : number,
  inLatLong   : number,
  min_bound   : T_Point,
  max_bound   : T_Point,
  nodeUrl     : string,
  has_lyrs    : boolean,       // indica si en la misma carpeta de img_filepath hay archivos lyr
  esc         : T_Escala,
  lyr         : ?T_EscalaLyr,
  info_lim    : ?T_InfoLim
};



export default class Img {
  static count = 0;
  
  obj    : T_ImgFile;
  overlay: Object;
  bounds : Object;
  old    : number;
  map_num: number;
  map    : Map;
  
  
  constructor(app: App, map: Map, img: T_ImgFile) {
    if (Map.google != null) {
      const google_maps = Map.google,
            bounds      = map.center_and_zoom(img.min_bound, img.max_bound),
            ov_opt      = {clickable: false, opacity: app.state.png_opacity},
            ov          = new google_maps.GroundOverlay(img.nodeUrl, bounds, ov_opt);
      
      ov.setMap(map.map);
      
      this.obj     = img;
      this.overlay = ov;
      this.old     = ++Img.count;
      this.map_num = map.props.num;
      this.map     = map;
      
      if (bounds != null) {
        this.bounds = bounds;
      }
      
      localforage.setItem(`${app.state.user.user_name}.last_png`, this.obj.img_filepath);
      
      map.notify_img_loaded(img.img_filepath, this);
    }
  }
  
  
  
  destroy(): void {
    this.overlay.setMap(null);
    
    this.map.notify_img_loaded(this.obj.img_filepath, null);
  }
  
  
  
  static destroy_in(dir: string, map: Map): void {
    _.keys(map.Img_List).forEach((path) => {
      if (takeDir(path) === dir) {
        map.Img_List[path].destroy();
        
        map.notify_img_loaded(path, null);
      }
    });
  }
  
  
  
  reload(app: App, ranges?: Array<T_NumPair>): void {
    if (Map.google != null) {
      const google_maps = Map.google;
      
      this.overlay.setMap(null);
      
      const ov_opt   = {clickable: false, opacity: app.state.png_opacity},
            hilight  = `&hilight_ranges=${ranges != null ? flatten_nums(ranges) : 'ALL'}`,
            esc_opts = app.esc_url_params() + hilight;
      
      this.obj.nodeUrl = this.obj.nodeUrl
                          .split('&')
                          .filter(par => par.indexOf('esc_') !== 0 && par.indexOf('hilight_ranges') !== 0)
                          .join('&') + esc_opts;
      
      // console.log(this.obj.nodeUrl)
      
      this.overlay = new google_maps.GroundOverlay(this.obj.nodeUrl, this.bounds, ov_opt);
      
      this.overlay.setMap(this.map.map);
    }
  }
}



// WEBPACK FOOTER //
// ./src/Img.js